export default "__VITE_ASSET__56c4fb10__"